import { useEffect, useState } from 'react'

export function useMarkdownNavigation(docId) {
  const [activeId, setActiveId] = useState('')
  const [headers, setHeaders] = useState([])

  const jumpTo = id => {
    if (typeof window !== 'undefined') {
      const anchorElement = document.getElementById(id)
      if (anchorElement) {
        const distanceFromTop = anchorElement.getBoundingClientRect().top
        const offset = 100
        window.scrollBy({
          top: distanceFromTop - offset,
          behavior: 'smooth',
        })
      }
    }
  }

  useEffect(() => {
    const anchorId = window.location.hash.replace('#', '')
    if (typeof window !== 'undefined' && typeof ResizeObserver !== 'undefined' && anchorId) {
      const createTimer = () => {
        const timer = setTimeout(() => {
          jumpTo(anchorId)
        }, 200)
        return timer
      }
      let timer = createTimer()
      const observer = new ResizeObserver(() => {
        clearTimeout(timer)
        timer = createTimer()
      })
      observer.observe(document.getElementById(docId))
      return () => {
        observer.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    const doc = document.getElementById(`${docId}`)
    if (!doc) return
    const headingElements = doc.querySelectorAll('h1, h2, h3, h4, h5, h6')
    const elements = Array.from(headingElements).filter(ele => ele.textContent.trim())
    const headersWithId = elements.map((ele, index) => {
      const id = `document-heading-${index}`
      ele.id = id

      return {
        id,
        text: ele.textContent,
        level: ele.tagName[1],
      }
    })

    setHeaders(headersWithId)
    if (headersWithId.length > 0) setActiveId(headersWithId[0].id)
    const handleScroll = () => {
      const tops = elements.map(heading => {
        const rect = heading.getBoundingClientRect()
        return {
          top: rect.top,
          id: heading.id,
        }
      })
      let currentInfo = {
        top: 2000,
      }
      tops.forEach((item, index) => {
        if (item.top > 40 && currentInfo.top > item.top) {
          currentInfo = { ...item, index }
        }
      })
      if (currentInfo.top <= 120) {
        setActiveId(currentInfo.id)
      } else {
        if (currentInfo.index > 0) {
          setActiveId(tops[currentInfo.index - 1].id)
        }
      }
    }
    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [docId])

  return { headers, activeId, jumpTo }
}
